"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ANIMATED_HACKER_GRID_ANIMATION_VARIANTS = void 0;
exports.ANIMATED_HACKER_GRID_ANIMATION_VARIANTS = {
    hidden: { opacity: 0 },
    show: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            ease: 'easeOut',
            duration: 0.7,
        },
    },
};
//# sourceMappingURL=constants.js.map